import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get token from localStorage or sessionStorage
    const token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
    
    console.log('🔗 [INTERCEPTOR] Processing request:', req.url);
    console.log('🔗 [INTERCEPTOR] Token exists:', !!token);
    
    if (token) {
      // Clone the request and add the authorization header
      const cloned = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      
      return next.handle(cloned).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            console.log('🔗 [INTERCEPTOR] 401 Unauthorized error detected');
            console.log('🔗 [INTERCEPTOR] Clearing authentication data');
            
            // Clear authentication data on 401 error
            this.authService.forceLogout();
            
            // Redirect to login if not already on a public route
            const publicRoutes = ['/login', '/signup', '/verify-email'];
            const currentUrl = window.location.pathname;
            const isPublicRoute = publicRoutes.some(route => currentUrl.startsWith(route));
            
            if (!isPublicRoute) {
              console.log('🔗 [INTERCEPTOR] Redirecting to login page');
              window.location.href = '/login';
            }
          }
          return throwError(() => error);
        })
      );
    }
    
    return next.handle(req);
  }
} 